import { useEffect } from 'react'
import { useFirebolt } from '@iq-firebolt/client'
import useAnalytics from 'hooks/useAnalytics'
import { getAnonymousID } from 'redline-client-sdk'

export default function useFireboltMetadata() {
  const { addRequestsMetadata, requestsMetadata } = useFirebolt()
  const currentTrackingProps = useAnalytics()
  const { anonymousId, fbCookies, gaCookies, ttqCookies, sourceUrl, sessionId, productId, flow } = currentTrackingProps || {}

  

  useEffect(() => {
    const userAgent = navigator?.userAgent
    addRequestsMetadata("userAgent", userAgent)
  }, [])

  useEffect(() => {
    if (!!flow) {
      addRequestsMetadata('flow', flow)
    }
  }, [flow])

  useEffect(() => {
    if (!!productId) {
      addRequestsMetadata('productId', productId)
    }
  }, [productId])

  useEffect(() => {
    if (!!sessionId) {
      addRequestsMetadata('sessionId', sessionId)
    }
  }, [sessionId])

  useEffect(() => {
    const anonymousIdFromCookie = getAnonymousID()  || null
    const anonymousIdWithCookie = anonymousId || anonymousIdFromCookie || null

    if (anonymousIdWithCookie && !requestsMetadata?.anonymousId) {
      addRequestsMetadata('anonymousId', anonymousIdWithCookie)
    }
  }, [anonymousId])

  useEffect(() => {
    if (!!fbCookies?.fbpId || !!fbCookies?.fbcId) {
      addRequestsMetadata('fbCookies', fbCookies)
    }
  }, [fbCookies])

  useEffect(() => {
    if (!!gaCookies?.gaId) {
      addRequestsMetadata('gaCookies', gaCookies)
    }
  }, [gaCookies])

  useEffect(() => {
    if (!!ttqCookies?.ttqId) {
      addRequestsMetadata('ttqCookies', ttqCookies)
    }
  }, [ttqCookies])

  useEffect(() => {
    if (!!sourceUrl) {
      addRequestsMetadata('sourceUrl', sourceUrl)
      addRequestsMetadata('startSourceUrl', sourceUrl)
    }
    addRequestsMetadata('currentSourceUrl', location.href)
  }, [sourceUrl])
}
